let items = document.querySelector('.header__inline-menu').querySelectorAll('details');
items.forEach((item) => {
  item.addEventListener('mouseover', () => {
    item.setAttribute('open', true);
    item.querySelector('ul').addEventListener('mouseleave', () => {
      item.removeAttribute('open');
    });
    item.addEventListener('mouseleave', () => {
      item.removeAttribute('open');
    });
  });
});

class AgeModal {
  ageValidateButton = document.getElementById('age-validate-button');
  modal = document.getElementById('age-modal');

  constructor() {
    this.ageValidateButton?.addEventListener('click', (e) => {
      e.preventDefault();
      this.setAgeCookie();
      this.hideAgeModal();
    });

    if (this.checkAgeCookie() || Shopify.designMode) {
      this.hideAgeModal();
    } else {
      this.showAgeModal();
    }
  }

  checkAgeCookie() {
    return this.readCookie('age-consent');
  }

  setAgeCookie() {
    return this.createCookie('age-consent', '1', { expires: 7 });
  }

  createCookie(name, value, days) {
    var expires = '';
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + value + expires + '; path=/';
  }

  readCookie(name) {
    var nameEQ = name + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }
}

var MyShopifyApp = {
  init: function () {
    console.log('Custom JS for Shopify Store');
    let ageModal = new AgeModal();
  },
};

MyShopifyApp.init();
